import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCustomerOrders } from 'app/entities/customer-order/customer-order.reducer';
import { ContractType } from 'app/shared/model/enumerations/contract-type.model';
import { AgreementStatus } from 'app/shared/model/enumerations/agreement-status.model';
import { createEntity, getEntity, reset, updateEntity } from './agreement.reducer';

export const AgreementUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const customerOrders = useAppSelector(state => state.customerOrder.entities);
  const agreementEntity = useAppSelector(state => state.agreement.entity);
  const loading = useAppSelector(state => state.agreement.loading);
  const updating = useAppSelector(state => state.agreement.updating);
  const updateSuccess = useAppSelector(state => state.agreement.updateSuccess);
  const contractTypeValues = Object.keys(ContractType);
  const agreementStatusValues = Object.keys(AgreementStatus);

  const handleClose = () => {
    navigate('/agreement');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCustomerOrders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    values.createdTimestamp = convertDateTimeToServer(values.createdTimestamp);

    const entity = {
      ...agreementEntity,
      ...values,
      customerOrder: customerOrders.find(it => it.id.toString() === values.customerOrder?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdTimestamp: displayDefaultDateTime(),
        }
      : {
          contractType: 'FIXED',
          status: 'NEW',
          ...agreementEntity,
          createdTimestamp: convertDateTimeFromServer(agreementEntity.createdTimestamp),
          customerOrder: agreementEntity?.customerOrder?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.agreement.home.createOrEditLabel" data-cy="AgreementCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.agreement.home.createOrEditLabel">
              Create or edit a Agreement
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="agreement-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.agreement.effectiveDate')}
                id="agreement-effectiveDate"
                name="effectiveDate"
                data-cy="effectiveDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.agreement.expirationDate')}
                id="agreement-expirationDate"
                name="expirationDate"
                data-cy="expirationDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.agreement.endDate')}
                id="agreement-endDate"
                name="endDate"
                data-cy="endDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.agreement.contractType')}
                id="agreement-contractType"
                name="contractType"
                data-cy="contractType"
                type="select"
              >
                {contractTypeValues.map(contractType => (
                  <option value={contractType} key={contractType}>
                    {translate(`crawlerBackendApp.ContractType.${contractType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.agreement.createdTimestamp')}
                id="agreement-createdTimestamp"
                name="createdTimestamp"
                data-cy="createdTimestamp"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.agreement.status')}
                id="agreement-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {agreementStatusValues.map(agreementStatus => (
                  <option value={agreementStatus} key={agreementStatus}>
                    {translate(`crawlerBackendApp.AgreementStatus.${agreementStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="agreement-customerOrder"
                name="customerOrder"
                data-cy="customerOrder"
                label={translate('crawlerBackendApp.agreement.customerOrder')}
                type="select"
              >
                <option value="" key="0" />
                {customerOrders
                  ? customerOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/agreement"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AgreementUpdate;
